const sdiClickDomains = {
  dev: 'http://localhost:7090',
  alpha: 'https://alpha.sdi.click',
  staging: 'https://staging.sdi.click',
  prod: 'https://sdi.click',
};
export const sdiClickDomain = sdiClickDomains[import.meta.env.VITE_STAGE.toLowerCase()];
